import { ActionIcon, Menu, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { breakpoints } from 'styles/theme.variables';

import {
  isDayOpened24Hours,
  hasMoreThanOneDay,
  isDayClosed,
} from 'components/MenuManagement/MenuEdit/Hours/ScheduleSelect/helpers';
import { DeleteIconSm, EditIconSm } from '@chownow/pantry/icons';

type EditScheduleMenuProps = {
  handle24Hours?: () => void;
  handleDeleteHours?: () => void;
  handleAddPeriod?: () => void;
  schedule: {
    uuid?: string;
    dayIndex?: string | number;
    startTime: string;
    endTime: string;
    appliedDate?: string;
    isPeriod?: boolean;
  };
  schedules?: {
    uuid?: string;
    dayIndex?: string | number;
    startTime?: string;
    endTime?: string;
  }[];
  isSpecial?: boolean;
  disableAddPeriod?: boolean;
  compact?: boolean;
};

export default function EditScheduleMenu({
  handle24Hours,
  handleDeleteHours,
  handleAddPeriod,
  schedule,
  schedules = [],
  isSpecial = false,
  disableAddPeriod = false,
  compact = false,
}: EditScheduleMenuProps) {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.maxMobile})`, undefined, {
    getInitialValueInEffect: false,
  });

  if (schedule.isPeriod) {
    return (
      <ActionIcon onClick={handleDeleteHours} size={compact ? 24 : undefined} variant="ghost">
        <DeleteIconSm />
      </ActionIcon>
    );
  }

  const scheduleForHelpers = { ...schedule, dayIndex: String(schedule.dayIndex ?? '') };

  return (
    <Menu position={isMobile ? 'top-end' : 'right'} middlewares={{ flip: true, shift: true }}>
      <Menu.Target>
        <ActionIcon
          disabled={!isSpecial && isDayClosed(scheduleForHelpers)}
          size={compact ? 24 : undefined}
          variant="ghost"
        >
          <EditIconSm />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown w={240}>
        <Menu.Item
          onClick={handle24Hours}
          disabled={
            hasMoreThanOneDay(
              String(schedule.dayIndex ?? ''),
              (schedules ?? []).map(s => ({
                ...s,
                dayIndex: String(s.dayIndex ?? ''),
                startTime: s.startTime ?? '',
                endTime: s.endTime ?? '',
              })),
            ) && !isSpecial
          }
        >
          <Text variant="label-md">
            {isDayOpened24Hours(scheduleForHelpers) ? 'Custom hours' : 'Open 24 hours'}
          </Text>
        </Menu.Item>
        {!isSpecial && !disableAddPeriod && (
          <Menu.Item onClick={handleAddPeriod} disabled={isDayClosed(scheduleForHelpers)}>
            <Text variant="label-md">Add period</Text>
          </Menu.Item>
        )}
        {isSpecial && (
          <Menu.Item onClick={handleDeleteHours}>
            <Text variant="label-md">Delete day</Text>
          </Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  );
}
